export const getUiBasePath = (): string => {
  const raw = import.meta.env.VITE_UI_BASE_PATH;
  // Detect the unresolved runtime-substitution placeholder. Vite inlines the
  // build-time value 'VITE_RUNTIME_UI_BASE_PATH' into the bundle, and
  // docker-entrypoint.sh replaces it with the container's actual
  // VITE_UI_BASE_PATH value at startup — but only if that env var is set.
  // Stacks that don't set the variable (most dev ECS stacks; app runs at '/')
  // end up with the literal placeholder string here, which is truthy and
  // would otherwise be passed to React Router as a bogus basename and match
  // no routes, rendering an empty page. Treat it as "not set" and fall back
  // to serving at root.
  if (!raw || raw.startsWith('VITE_RUNTIME_')) {
    return '/';
  }
  return raw === '/' ? '/' : raw.replace(/\/$/, '');
};

/**
 * Returns the UI base path as a prefix for building full paths.
 * Returns '' when serving at root, or '/v3' when serving at a sub-path.
 */
export const getUiBasePathPrefix = (): string => {
  const basePath = getUiBasePath();
  return basePath === '/' ? '' : basePath;
};

export const getApiBasePath = (): string => {
  const raw = import.meta.env.VITE_API_BASE_PATH;
  // Same unresolved-placeholder defense as getUiBasePath above: fall back to
  // the default '/v3' if the runtime substitution didn't fire.
  if (!raw || raw.startsWith('VITE_RUNTIME_')) {
    return '/v3';
  }
  return raw === '/' ? '' : raw.replace(/\/$/, '');
};
